module.exports = __webpack_public_path__ + "img/CardVirtual.fbbaf5e.png";